export default __webpack_public_path__ + "static/media/historia1.a381c9e4.png";